import React from "react";
import PropTypes from "prop-types";
import { SHELVES, noneShelf } from "../../Constants";
import { connect } from "react-redux";
import * as actions from "../../redux/book/bookActions";
const Book = (props) => {
  let imgUrl = "";
  if (props.theBook.imageLinks && props.theBook.imageLinks.smallThumbnail) {
    let thumb = props.theBook.imageLinks.smallThumbnail;
    thumb = thumb.replace("http:/", "https:/");
    imgUrl = `url(${thumb})`;
  }

  const setCurrentShelf = (shelfId) => {
    props.setShelf({ ...props.theBook, shelf: shelfId });
  };
  const getCurrentShelf = () => {
    for (const book in props.books) {
      if (props.theBook.id === props.books[book].id) {
        return props.books[book].shelf;
      }
    }
    return noneShelf;
  };
  const applyStyle = (shelfId) => {
    if (getCurrentShelf() === shelfId) {
      return "isSelected";
    }
    return "";
  };

  return (
    <div className="book">
      <div className="book-top">
        <a target="_blank" href={props.theBook.previewLink}>
          <div
            className="book-cover"
            style={{
              width: 128,
              height: 192,
              backgroundImage: imgUrl,
            }}
          ></div>
        </a>
        <div className="book-shelf-changer">
          <select
            disabled={props.theBook.isAd ? true : false}
            onChange={(event) => setCurrentShelf(event.target.value)}
            value={getCurrentShelf()}
          >
            <option value="move" disabled>
              Move to...
            </option>
            {SHELVES.map((s) => {
              return (
                <option
                  key={s.id}
                  className={applyStyle(s.id)}
                  disabled={getCurrentShelf() === s.id ? true : false}
                  value={s.id}
                >
                  {s.title}
                </option>
              );
            })}
            <option
              className={applyStyle(noneShelf)}
              disabled={getCurrentShelf() === noneShelf ? true : false}
              value={noneShelf}
            >
              None
            </option>
          </select>
        </div>
      </div>
      <div className="book-title">{props.theBook.title}</div>
      {props.theBook.authors
        ? props.theBook.authors.map((author) => (
            <div key={author} className="book-authors">
              {author}
            </div>
          ))
        : ""}
    </div>
  );
};

Book.propTypes = {
  theBook: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    books: state.bookReducer.books,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShelf: (book) => dispatch(actions.setShelf(book)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Book);
